import classcat from "classcat"

const styles = {
  xs: "mx-auto px-4 sm:px-6 md:max-w-2xl md:px-4 lg:px-2 justify-center",
  sm: "mx-auto px-4 sm:px-6 md:max-w-3xl md:px-4 lg:max-w-4xl lg:px-12 justify-center",
  md: "mx-auto px-4 sm:px-6 md:max-w-4xl md:px-4 lg:max-w-5xl lg:px-8 justify-center",
  lg: "mx-auto px-4 sm:px-6 md:max-w-6xl md:px-4 lg:max-w-7xl lg:px-8 justify-center",
}

export function Container({ size = "sm", className = "", ...props }) {
  return <div className={classcat([styles[size], className])} {...props} />
}
